import { createContext, useState } from "react";

export const DashboardContext = createContext();

export const DashboardContextProvider = ({ children }) => {
  const [sideToggle, setSideToggle] = useState(false);
  const [headerToggle, setHeaderToggle] = useState(false);

  const handleHeaderToggle = () => {
    setHeaderToggle(!headerToggle);
  };
  const handleSideToggle = () => {
    setSideToggle(!sideToggle);
  };

  return (
    <DashboardContext.Provider
      value={{
        sideToggle,
        handleSideToggle,
        headerToggle,
        handleHeaderToggle,
        setHeaderToggle,
        setSideToggle,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardContextProvider;
